<template>
  <div class="app">
    <div class="logo">
      <div class="but">
        <img src="../assets/logo10@2x.jpg" class="logo_img">
        <h3 class="logoText">薪福荟选</h3>
      </div>
    </div>
    <div class="body">
      <div class="header">
        <h3 class="text">薪福荟选店铺入驻信息</h3>
      </div>
      <div class="main">
        <div style="display: flex;">
          <div class="steps" :class="{steps_active: stepsNum === 1}">1</div>
          <div style="margin-left: 8px;height: 25px;line-height: 25px;font-size: 16px;font-weight: bold;">店铺主体信息</div>
          <div style="width: 100px;border-bottom: 2px solid #ECECEC;margin: 10px 12px;"></div>
          <div class="steps" :class="{steps_active: stepsNum === 2}">2</div>
          <div style="margin-left: 8px;height: 25px;line-height: 25px;font-size: 16px;font-weight: bold;">店铺基本信息</div>
          <div style="width: 100px;border-bottom: 2px solid #ECECEC;margin: 10px 12px;"></div>
          <div class="steps" :class="{steps_active: stepsNum === 3}">3</div>
          <div style="margin-left: 8px;height: 25px;line-height: 25px;font-size: 16px;font-weight: bold;">店铺证照信息</div>
        </div>
        <div class="one_steps" v-if="stepsNum === 1">
          <!-- 表单内容 -->
          <el-form :model="one_form" :rules="one_formRules" ref="one_Form" label-width="125px" class="oneform">
              <el-form-item label="店铺类型：" prop="posType">
                <el-radio-group v-model="one_form.posType" @input="resourceChange">
                  <el-radio v-model="one_form.posType" label="1"><span style="font-size: 15px;">专营店<span style="font-size: 14px;">（专门经营某个类目，多个授权品牌的商品店铺）</span></span></el-radio>
                  <el-radio v-model="one_form.posType" label="2"><span style="font-size: 15px;">旗舰店<span style="font-size: 14px;">（经营多个类目，多个授权品牌的商品店铺）</span></span></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="主营类目：">
                <!-- <el-radio-group v-model="one_form.categories" style="margin-right: 10px;">
                  <el-radio v-for="item in selectedCategory" :key="item.value" v-model="one_form.categories" label="1" border size="medium">{{ item.label }}</el-radio>
                </el-radio-group> -->
                <!-- <div style="margin-right: 10px;"> -->
                  <el-tag style="margin-right: 10px;" v-for="item in selectedCategory" :key="item.value">{{ item.label }}</el-tag>
                <!-- </div> -->
                <span style="cursor: pointer;color: #D9001B;" v-if="selectedCategory.length" @click="checkDetails">修改</span>
                <span style="cursor: pointer;color: #409EFF;" v-else @click="checkDetails">添加</span>
                <div>专营店仅可选择一个主营类目，主营类目决定您入驻后可经营类目的范围，不知到选哪个？您可尝试<span style="cursor: pointer; color: #2082dd;" @click="checkDetails">查看主营类目明细</span></div>
              </el-form-item>
              <el-form-item label="类目资质：">
                <div>选定主营类目后，需根据所选的<主营类目>提交相应的资质文件进行上传，详见
                  <span style="color: #2082dd;cursor: pointer;" @click="categoryTableData.length ? qualificationsVisible = true : ''">资质上传助手</span>
                </div>
                <el-table
                  :span-method="spanMethod"
                  :data="categoryTableData"
                  border
                  style="width: 100%"
                  height="600"
                  :header-cell-style="{background: '#F9FAFC', color: 'black'}"
                  :row-style="{height: '40px'}">
                  <el-table-column prop="class1Name" label="主营类目" width="180" align="center" />
                  <el-table-column prop="class2Name" label="需上传资质的类目" width="240" align="center">
                    <template #default="scope">
                      <!-- <div > -->
                        二级类目：{{ scope.row.class2Name }}
                      <!-- </div> -->
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="所需资质" align="center">
                    <template #default="scope">
                      <div v-if="!countSlashes(scope.row.name)">
                        《{{ scope.row.name }}》
                      </div>
                      <div v-else>
                        <span v-for="(item,index) in scope.row.name.split('/')" :key="index">
                          《{{ item }}》
                        </span>
                      </div>
                      <div style="color: #DC362E;" v-if="countSlashes(scope.row.name)">
                        （{{ countSlashes(scope.row.name) + 1 }}选1）
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" align="center">

                  </el-table-column>
                  <el-table-column label="资质" align="center">
                    <template #default="scope">
                      <div style="display: flex;justify-content: center;">
                        <span style="flex: 1;line-height: 30px;color:#169bd5;cursor: pointer;" v-if="scope.row.qualificationsImg.length > 0" @click="uploadQualificationsOpen(scope.$index)">
                          已上传({{ scope.row.qualificationsImg.length }})
                        </span>
                            <el-button style="height: 30px;background-color: #169bd5;line-height: 30px;color: #fff;padding: 0 10px;"
                              @click="uploadQualificationsOpen(scope.$index)"
                            >
                              {{ scope.row.qualificationsImg.length === 0 ? '点击上传' : '继续上传'}}
                            </el-button>
                          <!-- </el-upload> -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="上传执照照片:" class="form_logo form_backup uploadSeccess">
                <el-upload
                  action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
                  :limit="1"
                  :class="{uploadLogo: true, uploadLogoClass: uploadSwitch2}"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadseccess2"
                  list-type="picture-card"
                  :file-list="one_form.license"
                  :on-remove="handleRemove2">
                  <img class="logo_img" src="../assets/Group 1528@2x.png" v-if="!one_form.dialogImageUrl2">
                </el-upload>
                <span class="logo_text">建议尺寸200*200像素</span>
              </el-form-item>
          </el-form>
          <div style="width: 300px;margin: 0 auto;">
            <el-button style="width: 125px;" type="info" @click="backStep(1)">取消</el-button>
            <el-tooltip class="item" effect="light" content="若无法提交，请查看页面红字提醒，按照提醒修改" placement="right">
              <el-button style="width: 125px;" type="primary" @click="submitShop(1)">保存并下一步</el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="two_steps" v-if="stepsNum === 2">
            <el-form ref="two_form" :model="two_form" label-width="140px" label-position="left" :rules="two_formRules" class="oneform">
              <el-form-item label="店铺LOGO:" class="form_logo store_logo">
                <div>
                  <el-upload
                    action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
                    :limit="1"
                    :class="{uploadLogo: true, uploadLogoClass: uploadSwitch1}"
                    :before-upload="beforeAvatarUpload"
                    :on-success="uploadseccess"
                    list-type="picture-card"
                    :file-list="two_form.logoImg"
                    :on-remove="handleRemove">
                    <img class="logo_img" src="../assets/Group 1528@2x.png" v-if="!two_form.dialogImageUrl">
                  </el-upload>
                  <span class="logo_text">建议尺寸200*200像素</span>
                </div>
              </el-form-item>
              <el-form-item label="店铺名称:" class="form_name store_name" prop="name">
                <el-input v-model="two_form.name" placeholder="请输入店铺名称" maxlength="20" clearable/>
                <span class="logo_text">店铺名称建议20字符以内，超出在店铺页可能展示不全</span>
              </el-form-item>
              <el-form-item label="店铺简介:" class="form_intro" prop="intro">
                <el-input v-model="two_form.intro" type="textarea" :rows="3" placeholder="请输入店铺简介" maxlength="100"
                          show-word-limit clearable></el-input>
              </el-form-item>
              <!-- <el-form-item label="店铺所在地区:" class="form_area" prop="region">
                <el-cascader
                  v-model="two_form.region"
                  size="large"
                  :options="options_as"
                  class="formItemCascader"
                  @change="handleChange"
                  placeholder="请选择店铺所在地"
                  clearable
                />
              </el-form-item> -->
              <el-form-item label="店铺所在地:" class="form_area" prop="region">
                <el-cascader 
                  v-model="two_form.region"
                  size="large"
                  :options="options_as"
                  class="formItemCascader"
                  @change="handleChange"
                  placeholder="请选择店铺所在地"
                  clearable
                />
              </el-form-item>
              <el-form-item label="店铺备注:" class="form_backup">
                <el-input v-model="two_form.backup" type="textarea" :rows="3" placeholder="请输入备注" maxlength="100"
                          show-word-limit clearable></el-input>
              </el-form-item>
              <el-form-item label="店铺管理员昵称:" prop="posAdmin">
                <el-input v-model="two_form.posAdmin" placeholder="请输入店铺管理员昵称" clearable />
              </el-form-item>
              <el-form-item label="店铺联系电话:" class="form_name profit store_information" prop="shop_contact_number">
                <el-input v-model="two_form.shop_contact_number" :disabled="true" placeholder="请输入店铺联系电话" clearable/>
                <el-popover
                  placement="top-start"
                  width="20"
                  trigger="hover"
                  content="联系电话会作为审核成功短信通知、账号登录的依据。">
                  <el-button slot="reference" class="reference reference2">
                    <img src="../assets/Vector@2x.png" alt="" class="form_name_img"/>
                  </el-button>
                </el-popover>
              </el-form-item>
              <el-form-item label="店铺联系地址:" class="form_name store_address" prop="shop_contact_address">
                <el-input v-model="two_form.shop_contact_address" placeholder="请输入店铺联系地址" clearable maxlength="20"
                          show-word-limit/>
              </el-form-item>
            </el-form>
            <div style="width: 300px;margin: 0 auto;">
              <el-button style="width: 125px;" type="info" @click="backStep(2)">返回上一步</el-button>
              <el-tooltip class="item" effect="light" content="若无法提交，请查看页面红字提醒，按照提醒修改" placement="right">
                <el-button style="width: 125px;" type="primary" @click="submitShop(2)">保存并下一步</el-button>
              </el-tooltip>
            </div>
        </div>
        <div class="three_steps" v-if="stepsNum === 3">
          <el-form ref="three_form" :model="three_form" label-width="140px" label-position="left" :rules="three_formRules" class="oneform">
            <el-form-item label="企业名称:" class="form_backup" prop="enterprise_name">
              <el-select  
                v-model="three_form.enterprise_name"
                filterable  
                remote  
                reserve-keyword  
                placeholder="请输入企业名称"
                @blur="selectBlur"
                @change="selectQiye"
                :remote-method="remoteMethod"  
                :loading="loading">
                <el-option  
                  v-for="item in qiyeOptions"  
                  :key="item.value"  
                  :label="item.label"  
                  :value="item.value">  
                </el-option>  
              </el-select> 
            </el-form-item>
            <el-form-item label="企业类型:" class="form_backup" prop="type_of_enterprise">
              <el-input v-model="three_form.type_of_enterprise" placeholder="请输入企业类型" maxlength="20" show-word-limit clearable/>
            </el-form-item>
            <el-form-item label="信用代码:" class="form_backup" prop="credit_code">
              <el-input v-model="three_form.credit_code" placeholder="请输入统一社会信用代码" clearable/>
            </el-form-item>
            <el-form-item label="注册省份:" class="form_backup" prop="domicile">
              <el-select v-model="three_form.domicile" placeholder="请选择注册省份">
                <el-option
                  v-for="item in options_as"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="执照法人:" class="form_backup" prop="licensed_legal_person">
              <el-input v-model="three_form.licensed_legal_person" placeholder="请输入执照法人" maxlength="20" show-word-limit
                        clearable/>
            </el-form-item>
            <el-form-item label="注册资金:" class="form_backup" prop="registered_capital">
              <el-input v-model="three_form.registered_capital" placeholder="请输入注册资金" maxlength="20" show-word-limit clearable/>
            </el-form-item>
            <el-form-item label="注册时间:" class="form_backup" prop="issueTime">
              <!-- <el-input v-model="form.issueTime" placeholder="请输入注册时间" maxlength="30" show-word-limit clearable/> -->
              <el-date-picker
                prop="issueTime"
                v-model="three_form.issueTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择注册时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="证照期限:" class="form_backup">
              <el-input v-model="three_form.term_of_operation" placeholder="请输入证照期限" maxlength="30" show-word-limit clearable/>
            </el-form-item>
            <el-form-item label="经营范围:" class="form_backup" prop="business_scope">
              <el-input v-model="three_form.business_scope" type="textarea" :rows="3" 
                placeholder="请输入营业范围" maxlength="100" show-word-limit clearable>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="width: 300px;margin: 0 auto;">
            <el-button style="width: 125px;" type="info" @click="backStep(3)">取消</el-button>
            <el-button style="width: 125px;" type="primary" @click="submitShop(3)">提交</el-button>
          </div>
        </div>
        <el-dialog
          :visible.sync="dialogVisible_bos"
          class="dialogVisible_bos"
          width="30%"
          :show-close="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          center>
<!--          label-width="80px"-->
          <el-form
            ref="ruleForm"
            :rules="ruleF"
            :model="ruleForm"
            class="login-form"
            autocomplete="on"
            label-position="left">
            <div class="wrap">
<!--              label="手机号:"-->
              <div class="img_but">
                <img src="../assets/logo10@2x.jpg" class="logo_img" alt="" />
              </div>
              <div class="title_but">薪福荟选店铺入驻信息</div>
              <el-form-item class="phone">
                <el-input placeholder="请输入手机号" type="text" oninput="value=value.replace(/[^\d.]/g,'')" maxlength="11" v-model="ruleForm.phone" @input="checkPhone" class="input-with-select" />
                <i v-show="!ruleForm_phone" @click="clickPhone" class="iconfont icon-xiayibu"></i>
                <i v-show="ruleForm_phone && !icon_loading && !phone_state" class="iconfont icon-xiayibu" @click="phone_search" style="color: #494949"></i>
                <i v-show="ruleForm_phone && icon_loading" class="ips el-icon-loading"></i>
              </el-form-item>
<!--              label="验证码:"-->

              <el-form-item  class="yanzhengma" v-show="phone_state">
                <el-input v-model="ruleForm.yanzhengma" maxlength="6" placeholder="请输入验证码" clearable>
                  <el-button class="but_1" slot="append" v-show="countshow" type="primary"
                             @click="submityan('ruleForm')">发送验证码
                  </el-button>
                  <el-button class="but_2" slot="append" v-show="!countshow" disabled>{{ count }} s</el-button>
                </el-input>
              </el-form-item>
            </div>
          </el-form>

          <span slot="footer" class="dialog-footer" v-show="phone_state">
              <el-button style="background-color: #2082dd;border: #2082dd;" type="primary" @click="submitForm">下一步</el-button>
            </span>
        </el-dialog>
      </div>
    </div>

    <!-- 查看主营目录明细 -->
    <el-dialog
      title="主营类目明细"
      :visible.sync="checkDetailsVisible"
      width="70%"
      :before-close="checkDetailClose"
      center>
      <div style="height: 35px;line-height:35px;background: #D6EBFF;border: 1px solid #ADAFB1;display: flex;margin-bottom: 10px;">
        <div style="height: 35;line-height: 35px;">
          <i class="el-icon-warning" style="color: #3366FF;font-size: 24px;margin: 5px 10px 0 8px;"></i>
        </div>
        主营类目决定您店铺的经营范围，且提交后不可更改，请谨慎选择。
      </div>
      <div style="padding: 10px 10px;background: #F2F2F2;border-radius: 2px;">
        <div style="display: flex;justify-content: space-between;">
          <div style="font-size: 16px;font-weight: bold;color: #333;line-height: 40px;">选择主营类目</div>
          <div>
            <el-select
              ref="searchSelect"
              popper-class="select_check"
              v-model="selectCheckValue"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词搜索主营类目"
              :remote-method="serachCheckDetail"
              @change="selectCheckChange"
              :loading="loading">
              <el-option
                v-for="item in selectCheckOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <div>
                  <div>
                    <div style="font-weight: bold;margin-bottom: 5px;color: #333;">{{ item.label }}</div>
                    <!-- <div v-for="(items,indexs) in item.children" :key="indexs" style="margin-bottom: 10px;">
                      {{ items.label }}
                    </div> -->
                    <div v-for="(items,indexs) in item.children" :key="indexs" style="margin-bottom: 10px;">
                      <span v-html="highlightedText(items.label)"></span>
                    </div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="check">
          <!-- <div class="left_arrow" style="margin-right: 10px;">
            <img @click="leftArrow" src="../assets/left_arrow.png">
          </div> -->
          <div class="check_middle">
            <el-checkbox-group
              size="small"
              v-model="checkedClassifiCation"
              :max="checkedClassifCationMax">
              <el-checkbox border v-for="item in classifiCationCheckbox" 
                :label="item.value" :key="item.value" >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
            <!-- <checkboxWrapper @input="handleInput" v-model="checkedClassifiCation" :options="classifiCationCheckbox" :checkedClassifCationMax="checkedClassifCationMax" /> -->
          </div>
          <!-- <div class="right_arrow" style="margin-left: 10px;">
            <img @click="rightArrow" src="../assets/right_arrow.png">
          </div> -->
        </div>
      </div>
      <div style="margin-top: 10px;height: 230px;">
        <!-- {{ getClassDetail() }} -->
        <div style="color: #333;font-weight: bold;font-size: 17px;margin-bottom: 15px;">
          {{ checkedClassifiCation.length ? classifiCationCheckbox.filter(item => item.value == checkedClassifiCation[checkedClassifiCation.length - 1])[0].label : '' }}
        </div>
        <div v-if="checkedClassifiCation.length">
          <el-cascader-panel :options="getClassDetail"></el-cascader-panel>
          <!-- <el-cascader-panel :options="cascaderPanel"></el-cascader-panel> -->
        </div>
      </div>
      <div style="color: #4372FF;">
        <span style="cursor: pointer;">
          下载完成类目文档
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDetailClose">取 消</el-button>
        <el-button type="primary" @click="checkDetailConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 资质助手 -->
    <el-dialog
      title="资质助手"
      :visible.sync="qualificationsVisible"
      width="55%"
      center>
      <el-table
        :span-method="spanMethod"
        :data="categoryTableData"
        border
        style="width: 100%"
        height="600"
        :header-cell-style="{background: '#F9FAFC', color: 'black'}"
        :row-style="{height: '40px'}">
        <el-table-column prop="class1Name" label="主营类目" width="180" align="center" />
        <el-table-column prop="class2Name" label="需上传资质的类目" width="240" align="center">
          <template #default="scope">
            二级类目：{{ scope.row.class2Name }}
          </template>
          </el-table-column>
          <el-table-column prop="name" label="所需资质" align="center">
            <template #default="scope">
              <div v-if="!countSlashes(scope.row.name)">
                《{{ scope.row.name }}》
              </div>
              <div v-else>
                <span v-for="(item,index) in scope.row.name.split('/')" :key="index">
                  《{{ item }}》
                </span>
                </div>
                <div style="color: #DC362E;" v-if="countSlashes(scope.row.name)">
                  （{{ countSlashes(scope.row.name) + 1 }}选1）
                </div>
                </template>
          </el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qualificationsVisible = false">取 消</el-button>
        <el-button type="primary" @click="qualificationsVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 上传资质弹窗 -->
    <el-dialog
      title="上传资质"
      :visible.sync="uploadQualificationsDialog"
      width="55%"
      center
      @close="closeuploadQualificationsDialog"
    >
      <div style="display: flex;">
        <draggable v-model="uploadQualificationsList" @end="importGoodsImageListEvent">
          <div title="拖动改变顺序" v-for="(item, index) in uploadQualificationsList" :key="index" style="width: 130px;height: 130px;display: inline-block;margin-right: 15px;border: 1px solid #ccc;position: relative;border-radius: 10px;margin-top: 10px;">
            <!-- <el-tooltip class="item" effect="dark" content="拖动改变顺序" placement="top"> -->
              <el-image
                style="width: 100%;height: 100%;border-radius: 10px;"
                :src="item.url"
                :preview-src-list="[item.url]">
              </el-image>
            <!-- </el-tooltip> -->
            <i class="el-icon-close" style="background-color: #ccc;position: absolute;top: 0;right: 0;z-index: 999;" @click="deletteImportGoodsImageList(index)" />
          </div>
        </draggable>
        <!-- limit -->
        <el-upload
          action="#"
          multiple
          list-type="picture-card"
          :auto-upload="true"
          :file-list="uploadQualificationsList"
          :show-file-list="false"
          :before-upload="uploadQualificationsListBeforeUpload"
          :http-request="(file) => {uploadQualificationsCheckedFile(file)}"
          :on-remove="uploadQualificationsListRemove"
          accept=".png,.jpg,.jpeg,.gif"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submituploadQualifications">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {regionData, TextToCode, CodeToText} from 'element-china-area-data'
import axios from "axios";
import {getDate, isvalidPhone} from "../utils";
import  checkboxWrapper from './checkboxWrapper.vue'
import draggable from 'vuedraggable'
import { valid } from 'semver';

export default {
  name: 'PC',
  components:{
    checkboxWrapper,
    draggable
  },
  data() {
    return {
      headers: {
            'Content-type': 'multipart/form-data'
      },
      shop_phone: false, // 店铺联系电话 输入框的禁用状态
      state_image: 'zhong', // 审核状态的图片 {zhong,wan,ju}
      createTime: '', // 创建时间
      auditTime: '', // 审核时间
      schedule_active: 0, // 审核进度
      phone_state: false,
      success: '提交成功',
      floot_bottom: '提交',
      // dialogVisible_bos: true,
      dialogVisible_bos: false,
      dialog_visible: true,
      countshow: true,
      count: '',
      ruleForm: {
        phone: '15373582991',
        yanzhengma: '' // 验证码
      },
      stepsNum: 1, // 步骤
      uploadSwitch1: false,
      uploadSwitch2: false,
      uploadSwitch3: false,
      searchTimeout: null, // 用于存储 setTimeout 的 ID 
      one_form: {
        posType: '1',
        categories: [],
        license: [],
        dialogImageUrl2:''
      }, // 第一步表单
      selectedCategory: [], // 表单已选择主营类目
      checkDetailsVisible: false,
      selectCheckValue: '', // 搜索类目值
      selectCheckOptions: [], // 搜索框主营类目
      loading: false,
      checkedClassifiCation: [], // 主营类目复选框绑定数据
      allClassifiCationCheckbox: [], // 主营类目全部数据
      classifiCationCheckbox: [], // 复选框分类数据
      checkedClassifCationMax: 1,
      classifiCationPageNum: 0,
      claaaifiCationPageSize: 30,
      cascaderPanel:[],
      qualificationsVisible: false, // 资质助手弹窗
      qualificationsData: [], // 资质助手数据
      // checkDetailsVisible: false,
      uploadQualificationsDialog: false, // 上传资质弹窗
      uploadQualificationsList:[],
      categoryTableData: [],
      categoryListIndex: null, // 导入资质的索引
      uploadQualificationsList: [], // 图片数据
      viewState: false, // 是否是查看商品
      two_form:{
        logoImg:[], // 店铺logo
        dialogImageUrl: '',
        name: '', // 店铺名称
        intro: '', // 店铺简介
        region: [], // 店铺所在地
        options: '',
        backup: '', // 店铺备注
        posAdmin: '', // 店铺管理员昵称
        shop_contact_number: 'n', // 店铺联系电话,
        shop_contact_address: '', // 店铺联系地址
      }, // 第二步表单
      options_as: regionData, // 地区
      three_form:{
        enterprise_name: '', // 企业名称
        type_of_enterprise: '', // 企业类型
        credit_code: '', // 信用代码
        domicile: '', // 注册省份
        licensed_legal_person: '', // 执照法人
        registered_capital: '', // 注册资金
        issueTime: '', // 注册时间
        term_of_operation: '', // 证照期限
        business_scope: '', // 经营范围
      }, // 第三步表单
      qiyeOptions:[], // 企业集合
      searchQuery: '', // 用户输入的搜索词   
      loading: false, // 是否正在加载的标识 
      ruleForm_phone: false,
      icon_loading: false,
      dialogVisible: false,
      codeId: '', // codeId
      searchQuery: '',  
      showDropdown: false,  
      searchTimeout: null, 
      ruleF: {
        phone: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            //pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
          },
        ]
      },
      one_formRules: {
        posType:[
          {required: true}
        ]
      },
      two_formRules: {
        name: [
          {required: true, message: '请输入店铺名称', trigger: 'blur'},
        ],
        intro: [
          {required: true, message: '请输入店铺简介', trigger: 'blur'},
        ],
        region: [
          {type: 'array', required: true, message: '请选择店铺所在地区', trigger: 'change'},
        ],
        posAdmin: [
          {required: true, message: '请输入店铺管理员昵称', trigger: 'blur'},
        ],
        shop_contact_number: [
          {required: true, message: "请输入店铺联系方式", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            // pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            // pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
          },
        ],
        shop_contact_address: [
          {required: true, message: "请输入店铺联系地址", trigger: "blur"}
        ]
      },
      three_formRules:{
        enterprise_name:[
          { required: true, message: '请选择企业名称', trigger: 'change' }
        ],
        type_of_enterprise:[
          {required: true, message: '请输入企业类型', trigger: 'blur'}
        ],
        credit_code:[
          {required: true, message: '请输入信用代码', trigger: 'blur'}
        ],
        domicile:[
          { required: true, message: '请选择注册省份', trigger: 'change' }
        ],
        licensed_legal_person:[
          {required: true, message: '请输入执照法人', trigger: 'blur'}
        ],
        registered_capital:[
          {required: true, message: '请输入注册资金', trigger: 'blur'}
        ],
        issueTime:[
          {required: true, message: '请选择注册时间', trigger: 'change'}
        ],
        business_scope:[
          {required: true, message: '请输入营业范围', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    getTime() {
      return function (time) {
        return getDate(time)
      }
    },
    // 获取二三级分类数据
    getClassDetail(){
      if(this.checkedClassifiCation.length){
        return this.classifiCationCheckbox.filter(item => item.value == this.checkedClassifiCation[this.checkedClassifiCation.length - 1])[0].children
      }
    },
  },
  created(){
    // this.checkDetails()
    // this.checkDetailConfirm()
  },
  watch:{
    
  },
  methods: {
    highlightedText(text) {
      // 获取到搜索选择框内的文本内容
      const inputEl = this.$el.querySelector('.el-input--suffix input')
      if (!text || !inputEl.value) return text;
      // 转义正则特殊字符
      const escapedSearch = inputEl.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedSearch})`, 'gi');
      return text.replace(regex, '<span style="color: #2082dd;">$1</span>');
    },
    // 店铺类型切换
    resourceChange(){
      this.selectedCategory = []
      this.categoryTableData = []
    },
    // 查看主营目录明细
    async checkDetails(){
      this.checkDetailsVisible = true
      const { data } = await axios.get('/goodClass/goodClassTree?className=')
      if(data.code === 200){
        this.allClassifiCationCheckbox = this.getChunks(data.extend.data)
        this.classifiCationCheckbox = this.allClassifiCationCheckbox[this.classifiCationPageNum]
        this.checkedClassifiCation = this.selectedCategory.map(item => item.value)
        // console.log(this.allClassifiCationCheckbox)
        // forEach(item => {
        //   this.selectCheckOptions.push({value: item.value,label: item.label})
        // })
      }
      if(this.one_form.posType == '1'){
        this.checkedClassifCationMax = 1
      }else{
        this.checkedClassifCationMax = 100
      }

      // if(this.selectedCategory.length) this.checkedClassifiCation = this.selectedCategory.map(item => item.value)
    },
    getChunks(arr, chunkSize = 30) {
      const result = []
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize))
      }
      return result
    },
    // 主营类目弹窗关闭
    checkDetailClose(){
      this.checkDetailsVisible = false
      this.loading = false
      this.selectCheckOptions = []
      this.checkedClassifiCation = []
      this.classifiCationCheckbox = []
      this.classifiCationPageNum = 0
    },
    // 确定主营类目
    async checkDetailConfirm(){
      // if(this.checkedClassifiCation.length === 0){
      //   return this.$message.warning('还未选择类目')
      // }
      const array = []
      // console.log(this.checkedClassifiCation,this.classifiCationCheckbox)
      this.checkedClassifiCation.forEach(item => {
        array.push(...this.classifiCationCheckbox.filter(item2 => {
          if( item2.value === item ){
            return item2
          }
        }))
        // console.log(array)
      })
      this.selectedCategory = array
      const params = this.checkedClassifiCation
      // const params = [670]
      this.checkDetailClose()
      const { data } = await axios.post('/pos/getCategory', params)
      if(data.code === 200){
        // this.selectedCategory = data.extend.data
        this.categoryTableData = data.extend.data.map(item => {
          item.qualificationsImg = [];
          return item;
        })
        // console.log(this.categoryTableData,data.extend.data)
      }
      // console.log(data)
    },
    // 打开已上传的导入商品的图片信息弹窗
    uploadQualificationsOpen(index){
      this.categoryListIndex = index
      // console.log(this.categoryTableData[index],index)
      this.categoryTableData[index].qualificationsImg.forEach(item => {
        this.uploadQualificationsList.push({
          name: item.name,
          url: item.url
        })
      })
      this.uploadQualificationsDialog = true
    },
    // 图片超出个数提示
    uploadQualificationsListOnExceed(){
      // this.$message.warning(this.importGoodsImgTitle + '最多上传' + this.importGoodsImgLimit + '张')
    },
    // 资质图片
    uploadQualificationsListBeforeUpload(file, type, index){
      // 允许上传的文件格式列表
      let acceptList = ['jpg', 'png', 'jpeg', 'gif']
      // 根据文件名获取文件的后缀名
      let fileType = file.name.split('.').pop().toLowerCase()
      // 判断文件格式是否符合要求
      if (acceptList.indexOf(fileType) === -1) {
          this.$message.error('只能上传 jpg/png/jpeg/gif 格式的图片 !')
          return false
      }
      // 文件大小限制，10MB  
      const maxSize = 10 * 1024 * 1024 // 10MB限制
      // 检查文件是否过大  
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB !')
        return false
      }
      return true
    },
    async uploadQualificationsCheckedFile(file){
      let formData = new FormData()
      formData.append('file', file.file)
      // console.log(formData)
      const { data } = await axios.post('https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if(data.code === 200){
        this.uploadQualificationsList.push({
          name: file.file.name,
          uid: file.file.uid,
          url: data.extend.resultMap.url
        })
        this.$message.success('图片上传成功')
      }
    },
    // 资质图片上传
    uploadQualificationsListRemove(file, fileList){
      this.uploadQualificationsList.forEach((item,index) => {
        if(file.uid === item.uid){
          this.uploadQualificationsList.splice(index, 1)
        }
      })
    },
    // 确定图片
    submituploadQualifications(){
      this.categoryTableData[this.categoryListIndex].qualificationsImg = this.uploadQualificationsList.slice()
      this.categoryListIndex = null
      this.uploadQualificationsList = []
      this.uploadQualificationsDialog = false
    },
    closeImportGoodsImgDialog(){
      this.categoryListIndex = null
      this.uploadQualificationsList = []
      this.uploadQualificationsDialog = false
    },
    // 监听拖动改变图片位
    importGoodsImageListEvent() {
      const arr = []
      this.uploadQualificationsList.forEach(item => {
        arr.push(item)
      })
      this.uploadQualificationsList = arr
      // console.log(this.uploadQualificationsList)
    },
    deletteImportGoodsImageList(index) {
      this.uploadQualificationsList.splice(index, 1)
    },
    // 关闭上传资质弹窗
    closeuploadQualificationsDialog(){

    },
    // 合并单元格
    spanMethod({ row, column, rowIndex, columnIndex, }) {
      // this.categoryTableData = this.categoryTableData.sort((a, b) => a.date.localeCompare(b.date))
      //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
      const fields = ['class1Name','class2Name']
      // 当前行的数据
      const cellValue = row[column.property]
      // 判断只合并定义字段的列数据
      if (cellValue && fields.includes(column.property)) {
        const prevRow = this.categoryTableData[rowIndex - 1] //上一行数据
        let nextRow = this.categoryTableData[rowIndex + 1] //下一行数据
        // 当上一行的数据等于当前行数据时，当前行单元格隐藏
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
          let countRowspan = 1 //用于合并计数多少单元格
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = this.categoryTableData[++countRowspan + rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    countSlashes(str) {
      if (!str.includes('/')) return 0
      return str.split('/').length - 1
    },
    // 搜索主营类目
    serachCheckDetail(query){
      if (query !== '') {
        this.loading = true
        setTimeout( async () => {
          const { data } = await axios.get(`/goodClass/goodClassTree?className=${query}`)
          if(data.code === 200){
            this.selectCheckOptions = this.flattenTreeToPaths(data.extend.data)
            // console.log(this.selectCheckOptions)
          }
          this.loading = false
        }, 200)
      } else {
        this.selectCheckOptions = []
      }
    },
    // 三级数据结构转二级数据结构
    flattenTreeToPaths(data) {
      return data.map(item => {
        const result = {
          value: item.value,
          label: item.label,
          children: []
        }
        function dfs(node, path) {
          const currentPath = [...path, node.label || node.lable]
          if (!node.children || node.children.length === 0) {
            result.children.push({
              label: currentPath.join('/')
            })
          } else {
            node.children.forEach(child => dfs(child, currentPath))
          }
        }
        dfs(item, [])
        return result
      })
    },
    // 选中某一个主营类目
    selectCheckChange(value){
      this.checkedClassifiCation = [value]
      
      // console.log(this.checkedClassifiCation)
    },
    getClassTitle(){
      const obj = this.classifiCationCheckbox.filter(item => item.value == this.checkedClassifiCation[this.checkedClassifiCation.length - 1])
      // console.log(obj[0].label)
      return obj.label
    },
    // 上一页
    leftArrow(){
      if(this.classifiCationPageNum > 0){
        this.classifiCationPageNum--
        this.classifiCationCheckbox = this.allClassifiCationCheckbox[this.classifiCationPageNum].map(item => {
          return ({value: item.value,label: item.label})
        })
        if(this.selectedCategory.length === 1){
          console.log(this.classifiCationCheckbox.some(item => item.value === this.selectedCategory[0].value))
          console.log(this.classifiCationCheckbox,this.selectedCategory[0])
          if(this.classifiCationCheckbox.some(item => item.value === this.selectedCategory[0].value)){
            this.checkedClassifiCation = [this.selectedCategory[0].value]
            console.log(555)
          }else{
            this.checkedClassifiCation = []
          }
        }else{

        }
      }
    },
    // 下一页
    rightArrow(){
      if(this.classifiCationPageNum < this.allClassifiCationCheckbox.length - 1){
        this.classifiCationPageNum++
        console.log(this.checkedClassifiCation)
        this.classifiCationCheckbox = this.allClassifiCationCheckbox[this.classifiCationPageNum].map(item => {
          return ({value: item.value,label: item.label})
        })
        if(this.selectedCategory.length === 1 || this.checkedClassifiCation.length === 1){
          if(this.classifiCationCheckbox.some(item => item.value === this.selectedCategory[0].value)){
            this.checkedClassifiCation = [this.selectedCategory[0].value]
          }else{
            this.checkedClassifiCation = []
          }
        }else{

        }
      }
    },
    async remoteMethod(query) { 
      if (query !== '') {
          this.loading = true;
          // 清除之前的定时器  
          if (this.searchTimeout) {  
            clearTimeout(this.searchTimeout);  
          }  
          // 设置新的定时器  
          this.searchTimeout = setTimeout(async () => {
            this.loading = false
            // 调用远程搜索方法  
            const { data } = await axios.get('/pos/getCompany?keyword=' + `'${query}'`)
            this.qiyeOptions = data.extend.data.map(item => {
              return {value:item.companyName, lable:item.creditCode, ...item}
            })
            // console.log(this.qiyeOptions);
          }, 1200)
        } else {
          this.two_form.options = [];
      }
    },  
    // 让选择框失焦时input不会被清空
    selectBlur(e){
      this.three_form.enterprise_name = e.target.value
      this.$forceUpdate()
    },
    selectQiye(item){
      this.qiyeOptions.forEach(item2 => {
        if(item === item2.companyName){
          this.three_form.type_of_enterprise = item2.companyType
          this.three_form.credit_code = item2.creditCode
          this.three_form.licensed_legal_person = item2.faRen
          this.three_form.registered_capital = item2.regMoney
          this.three_form.issueTime = item2.issueTime
        }
      })
    },
    checkPhone(value) {
      this.ruleForm_phone = !!isvalidPhone(value);
      this.phone_state = false
    },
    clickPhone(){
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if(reg.test(this.ruleForm.phone) === false){
        this.$message.error('请检查手机号格式是否正确')
      }
    },
    phone_search() { // 查询手机号是否存在
      // console.log(6666666);
      this.icon_loading = true
      this.schedule_active = 0
      // this.form.shop_contact_number = this.ruleForm.phone

      // this.dialog_visible = false
      // this.dialogVisible_bos = false
      if (this.ruleForm.phone !== '') {
        const url = "pos/checkPhoneIsExist?phone=" + this.ruleForm.phone
        axios.get(url).then(res => {
          setTimeout(() => {
            this.icon_loading = false
            if (res.data.code === 200) {
              const rps = res.data.extend.data
              if (rps === false) {
                // this.$message.error('您的手机号已有登录权限，暂不支持入驻店铺，可更换其他手机号申请入驻!')
                this.phone_state = true
                this.submityan('ruleForm')
              } else {
                  // this.phone_state = true
                // if (rps.flag){
                //   // this.schedule_active = rps.state += 2
                // } else {
                this.shop_phone = true
                this.dialogVisible_bos = false
                this.two_form.shop_contact_number = this.ruleForm.phone
                this.getPosDetailVOByPhone(this.ruleForm.phone)
                // }
              }
            } else if (res.data.code === 100) {
              this.$message.error(res.data.extend.data)
            } else {
              this.$message.error('请检查手机号格式是否正确')
            }
          }, 1500)
        })
      } else {
        this.$message.error('手机号不可为空!')
      }
    },
    // 根据手机号查询数据
    getPosDetailVOByPhone(phone) {
      const that = this
      const url = 'pos/getPosDetailVOByPhone?phone=' + phone
      axios.get(url).then(res => {
        if (res.data.code === 200) {
          // let form = that.ruleForm
          const data = res.data.extend.data
          const dats = data.posAddress.split(',')
          let loc = ''
          let options = []
          if (!parseInt(dats[0])) {
            loc = data.posAddress
            dats[0] === dats[1] ? dats[1] = '市辖区' : dats[1]
            if (dats.length > 1) {
              if (TextToCode[dats[0]].code) {
                options = ([TextToCode[dats[0]].code, TextToCode[dats[0]][dats[1]].code, TextToCode[dats[0]][dats[1]][dats[2]].code])
              } else {
                options = ([CodeToText[dats[0]], CodeToText[dats[0]][dats[1]], CodeToText[dats[0]][dats[1]][dats[2]]])
              }
            } else {
              options = []
            }
          } else {
            const address = data.posAddress.split(',')
            options = address
            address.forEach(item => {
              loc += CodeToText[item] + ','
            })
          }
          let img1 = ''
          // let img2 = ''
          data.imgTypeList.map(item => {
            if (item.imgType === 0) {
              img1 = item.imgUrl
            }
          })
          // that.form = {
          //   dialogImageUrl: data.posImg,
          //   name: data.posName,
          //   intro: data.posDesc,
          //   options: loc,
          //   region: options,
          //   backup: data.remakeName,
          //   type: data.takeincolonel,
          //   profit: data.colonelscale,
          //   noProfit: data.colonelbscale,
          //   posAdmin: data.posAdmin,
          //   shop_contact_number: data.telPhone,
          //   shop_contact_address: data.contactAddress,
          //   license: [],
          //   license2: [],
          //   dialogImageUrl2: img1,
          //   dialogImageUrl3: img2,
          //   enterprise_name: data.companyName, // 企业名称
          //   type_of_enterprise: data.companyType, // 企业类型
          //   credit_code: data.creditCode, // 信用代码
          //   licensed_legal_person: data.faRen, // 执照法人
          //   registered_capital: data.regMoney, // 注册资本
          //   issueTime: data.issueTime, // 注册时间
          //   term_of_operation: data.certificateIndate, // 营业期限
          //   business_scope: data.certificateRange, // 经营范围
          //   domicile: data.address // 注册地
          // }
          // this.categoryTableData = 
          this.one_form = {
            posType: data.posType,
            license: [{url: img1}]
          }
          this.two_form = {
            posName: data.name,
            intro: data.posDesc,
            // options: data.posAddress,
            options: loc,
            region: options,
            posAdmin: data.posAdmin,
            backup: data.remakeName,
            shop_contact_number: data.telPhone,
            shop_contact_address: data.contactAddress,
            dialogImageUrl: data.posImg,
            logoImg: [{url: data.posImg}]
          }
          this.three_form = {
            enterprise_name: data.companyName,
            type_of_enterprise: data.companyType,
            credit_code: data.creditCode,
            licensed_legal_person: data.faRen,
            registered_capital: data.regMoney,
            issueTime: data.issueTime,
            term_of_operation: data.certifficateIndate,
            domicile: data.provinceId
          }
        
          // that.form.logoImg = []
          // that.form.logoImg.push({url: data.posImg})
          // that.form.license.push({url: img1})
          // if(img2){
          //   that.form.license2.push({url: img2})
          // }
          // that.floot_bottom = '更新'
          // console.log(data,that.form.license2,'数据555');
          that.posid = data.posId
          that.dialogVisible_bos = false
        }
      })
    },
    submitForm() { // 查询店铺
      const that = this
      if (that.ruleForm.yanzhengma !== '') {
        const url = 'pos/getPosEntityByPhone'
        const data = {
          code: that.ruleForm.yanzhengma,
          phone: that.ruleForm.phone
        }
        axios.post(url, data).then(res => {
          if (res.data.code === 200) {
            this.shop_phone = true
            this.dialogVisible_bos = false
            this.form.shop_contact_number = this.ruleForm.phone
          } else {
            // this.$message.error('您的手机号已有登录权限，暂不支持入驻店铺，可更换其他手机号申请入驻!')
            this.$message.error(res.data.extend.data)
          }
        })
      } else {
        that.$message.error('验证码不可为空!')
      }
    },
    // 发送验证码
    submityan(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countshow = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.countshow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          const url1 = 'login/sendSms?phone=' + this.ruleForm.phone
          axios.get(url1).then(res => {
            if (res.data.code === 200) {
              const data = res.data.extend
              this.codeId = data.phoneCodeId
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 店铺logo图片上传事件
    beforeAvatarUpload(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      console.log(file.type,isJPG)
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式或者 PNG 格式')
      }
      return isJPG
    },
    uploadseccess(response, file, fileList) {
          if (response.code === 200) {
            this.two_form.dialogImageUrl = response.extend.resultMap.url // 店铺logo
            this.two_form.logoImg.push(response.extend.resultMap) // 店铺logo
            this.uploadSwitch1 = this.two_form.dialogImageUrl !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove()
          }
    },
    // 删除店铺logo图片事件
    handleRemove() {
      this.two_form.dialogImageUrl = ''
      this.two_form.logoImg = []
      this.uploadSwitch1 = false
      // this.$message({
      //   message: '图片删除成功',
      //   type: 'success'
      // })
    },
    // 店铺证照图片上传事件
    uploadseccess2(response, file, fileList) {
          if (response.code === 200) {
            this.one_form.dialogImageUrl2 = response.extend.resultMap.url // 商品主图
            this.one_form.license.push(response.extend.resultMap) // 商品主图
            this.uploadSwitch2 = this.one_form.dialogImageUrl2 !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove2()
          }
    },
    // 删除店铺证照图片事件
    handleRemove2() {
      this.one_form.dialogImageUrl2 = ''
      this.one_form.license = []
      this.uploadSwitch2 = false
    },
    // 其他资质图片上传事件
    uploadseccess3(response, file, fileList) {
          if (response.code === 200) {
            this.form.dialogImageUrl3 = response.extend.resultMap.url // 商品主图
            this.form.license2.push(response.extend.resultMap) // 商品主图
            this.uploadSwitch3 = this.form.uploadSwitch3 !== ''
            this.$message({
              message: '上传图片成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '上传图片失败',
              type: 'error'
            })
            // this.handleRemove3()
          }
    },
    // 删除其他资质图片事件
    handleRemove3() {
      this.form.dialogImageUrl3 = ''
      this.form.license2 = []
      this.uploadSwitch3 = false
    },
    // 根据省市区选择器得到最终的地址信息
    handleChange() {
      let loc = ''
      for (let i = 0; i < this.two_form.region.length; i++) {
        loc += CodeToText[this.two_form.region[i]] + ','
      }
      this.two_form.options = loc.slice(0, loc.length - 1)
    },
    // 返回上一步
    backStep(state){
      if(state === 1){
        this.stepsNum = 1
      }else if(state === 2){
        this.$refs.two_form.clearValidate()
        this.stepsNum = 1
      }else{
        this.$refs.three_form.clearValidate()
        this.stepsNum = 2
      }
    },
    // 提交事件
    submitShop(state){
      if(state === 1){
        // const arr = this.groupByClass(this.categoryTableData.filter(item => {
        //   return item.qualificationsImg.length
        // }))
        // console.log(JSON.stringify(arr),'树')
        if(this.selectedCategory.length === 0) return this.$message.error('未选择主营类目')
        if(this.one_form.license.length === 0 && this.one_form.dialogImageUrl2 === '') return this.$message.error('执照照片必须上传')
        this.stepsNum = 2
      }else if(state === 2){
        this.$refs.two_form.validate((valid) => {
          if (valid) {
            this.stepsNum = 3
          }
        })
      }else{
        this.$refs.three_form.validate(async (valid) => {
          if (valid) {
            const qualificationList = this.groupByClass(this.categoryTableData.filter(item => {
              return item.qualificationsImg.length
            }))
            const params = {
              posName: this.two_form.name,
              posDesc: this.two_form.intro,
              posAddress: this.two_form.options,
              posAdmin: this.two_form.posAdmin,
              remakeName: this.two_form.backup,
              telPhone: this.two_form.shop_contact_number,
              contactAddress: this.two_form.shop_contact_address,
              posImg: this.two_form.dialogImageUrl,
              imgTypeList: [],
              contactAddress: this.two_form.shop_contact_address,
              companyName: this.three_form.enterprise_name,
              companyType: this.three_form.type_of_enterprise,
              creditCode: this.three_form.credit_code,
              faRen: this.three_form.licensed_legal_person,
              regMoney: this.three_form.registered_capital,
              issueTime: this.three_form.issueTime,
              certifficateIndate: this.three_form.term_of_operation,
              provinceId: this.three_form.domicile,
              posType: this.one_form.posType,
              // class1Id: this.selectedCategory.map(item => item.value),
              qualificationList
            }
            if(this.one_form.dialogImageUrl2 !== ''){
              params.imgTypeList.push({imgUrl: this.one_form.dialogImageUrl2, imgType: 0})
            }
            // if(this.two_form.dialogImageUrl3 !== ''){
            //   params.imgTypeList.push({imgUrl: this.two_form.dialogImageUrl3, imgType: 1})
            // }
            const { data } = await axios.post('pos/addNewPos', params)
            if(data.code === 200){

            }
          }
        })
      }
    },
    // 将平铺数据变成树状数据
    groupByClass(arr) {
      const result = []
      const class1Map = new Map()
      arr.forEach(item => {
        const { class1Id, class2Id } = item
        if (!class1Map.has(class1Id)) {
          class1Map.set(class1Id, {
            class1Id,
            class2List: []
          })
        }
        const class1Group = class1Map.get(class1Id)
        let class2Group = class1Group.class2List.find(c2 => c2.class2Id === class2Id)
        if (!class2Group) {
          class2Group = {
            class2Id,
            qualifications: []
          }
          class1Group.class2List.push(class2Group)
        }
        class2Group.qualifications.push({
          qualificationId: item.id,
          fileUrls: item.qualificationsImg.map(item => item.url),
          remarks: item.remark
        })
      })
      result.push(...class1Map.values())
      return result
    }
  }
}
</script>

<style lang="less" scoped>
.main{
  .steps{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #7F7F7F;
    text-align: center;
    padding-top: 6px;
    box-sizing: border-box;
    color: white;
  }
  .steps_active{
    background-color: #FF3B30;
  }
}

li {
  list-style: none;
}

.app {
  margin: 0 auto;
  width: 80vw;

  .logo {
    height: 100px;

    .but {
      width: 100%;

      .logo_img {
        width: 50px;
        height: 100%;
        vertical-align: middle;
      }

      .logoText {
        display: inline-block;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
  }

  /*表单*/

  .body {
    width: 100%;
    height: auto;
    background-color: #fff;
    opacity: 1;
    border: 2px solid #EBEBEB;
    margin-bottom: 100px;

    .header {
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      background: #F4F4F4;
      border-radius: 0 0 0 0;
      opacity: 1;
      border-bottom: 2px solid #EBEBEB;

      .text {
        font-size: 20px;
        margin: 0;
        line-height: 50px;
        text-align: center;
      }
    }

    .main {
      margin: 45px 90px 20px;
      
      .oneform {
        padding: 20px 0;

        /deep/ .el-form-item__label {
          font-weight: 700;
          font-size: 16px;
          color: #000;
        }

        /deep/ .el-divider--horizontal {
          background-color: #F3F3F3;
        }


        .el-input, .el-textarea, .el-select {
          width: 60%;
        }
        .store_logo {
          /deep/ .el-form-item__label::before {
            content: '* ';
            color: red;
          }

          /deep/ .el-form-item__content {
            display: flex;
            position: relative;
          }
          .logo_img {
            width: 75px;
            height: 56px;
            vertical-align: middle;
          }
          .uploadLogo {
            /deep/ .el-upload {
              //display: none;
              background: none;
              border: 0;
            }
          }
          .uploadLogoClass {
            /deep/ .el-upload {
              display: none;
            }
          }
        }
        .reference {
          border: none;
          background: none;
          padding: 0;
        }

        .reference2 {
          padding-left: 5px;
          .form_name_img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .uploadSeccess {
          /deep/ .el-form-item__label::before {
            content: '* ';
            color: red;
          }
          .logo_img {
            width: 75px;
            height: 56px;
            vertical-align: middle;
          }
          .uploadLogo {
            /deep/ .el-upload {
              //display: none;
              background: none;
              border: 0;
            }
          }
          .uploadLogoClass {
            /deep/ .el-upload {
              display: none;
            }
          }
        }

      .dialog_prompt {
        /deep/ .el-dialog--center {
          padding: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          .el-dialog__header {
            padding: 0;
          }

          .el-dialog__body {
            padding: 0;
            text-align: center;
          }
        }
      }

      .dialogVisible_bos {
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/ .el-dialog--center {
          //box-shadow: none;
          //-webkit-box-shadow: none;
          margin-top: 0 !important;
          border-radius: 10px;
          box-shadow: 0.3px 1.3px 2.6px #D8EAE5, 2px 3px 21px #D8EAE5;

          .el-dialog__header {
            display: none;
            //border-bottom: 1px solid #cccccc;
            //
            //.el-dialog__title {
            //  font-weight: 900;
            //  color: #000;
            //}
          }

          .el-dialog__body {
            padding-bottom: 0;

            .login-form {
              box-sizing: border-box;

              .wrap {
                text-align: center;
                padding: 1vw;
                .img_but {
                  .logo_img {
                    width: 60px;
                  }
                }
                .title_but {
                  display: inline-block;
                  font-size: 22px;
                  font-weight: 900;
                  margin-top: 10px;
                  margin-bottom: 36px;
                  color: #494949;
                }

                .el-form-item__label {
                  font-weight: 700;
                }

                .phone {
                  position: relative;
                  margin-bottom: 0;

                  .input-with-select {
                    .el-input__inner {
                      border-radius: 12px;
                    }
                    .el-input-group__append {
                      background-color: #fbfbfb;

                      .iconfont {
                        font-weight: 900;
                        font-size: 24px;
                      }
                    }
                  }
                  .iconfont,.ips {
                    position: absolute;
                    right: 10px;
                    top: 0;
                    color: #929292;
                    //background-color: orange;
                    font-weight: 900;
                    font-size: 25px;
                  }
                  .ips {
                    top: 7px;
                    color: #000;
                  }
                }

                .yanzhengma {
                  margin-top: 12px;
                  margin-bottom: 0;
                  .el-form-item__content {
                    .el-input {
                      .el-input__inner {
                        border-top-left-radius: 12px;
                        border-bottom-left-radius: 12px;
                      }
                      .el-input-group__append {
                        border-top-right-radius: 12px;
                        border-bottom-right-radius: 12px;
                      }
                    }
                  }

                  .el-form-item__label:before {
                    content: '*';
                    color: #f36e70;
                    margin-right: 4px;
                  }

                  .but_2 {
                    margin: 0;

                    span {
                      color: #000;
                    }
                  }

                  .but_2:hover {
                    border-left: none;
                    background-color: #f5f7fa;
                  }
                }
              }
            }
          }

          .el-dialog__footer {
            .dialog-footer {
              width: 100%;
              display: flex;
              justify-content: space-around;
              .el-button--primary {
                font-size: 13px;
                background-color: #2082dd;
                border-color: #2082dd;
                width: calc(100% - 40px);
                border-radius: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.dialogVisible_state_log {
  animation: anim-open 3s ease;
}

.dialogVisible_out_log {
  animation: anim-close 3s ease;
}

@keyframes anim-open {
  0% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes anim-close {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}

.dropdown {  
  /* 样式代码，如位置、宽度、背景等 */  
  position: absolute;  
  background-color: #fff;  
  border: 1px solid #ccc;  
  margin-top: 2px;  
  max-width: 200px;  
  z-index: 10;  
}
.select_check{
  // color: red;
  .el-select-dropdown__item{
    height: auto;
    line-height: 100%;
  }
  .el-select-dropdown__wrap {
    height: 450px;
    max-height: none;
  }
}
.check{
  display: flex;
  margin: 10px auto 0;
  height: 160px;
  width: 95%;
  // background: goldenrod;
  .left_arrow,
  .right_arrow{
    padding-top: 57px;
    // background: green;
    flex: 1;
    img{
      display: block;
      width: 25px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .check_middle{
    // width: 86%;
    // background: yellowgreen;
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      text-align: center;
      width: 100%;
      height: 100%;
      
      .el-checkbox {
        flex: 0 0 10%;  // 每行5个（100% / 5 = 20%）
        margin: 12px 6px;
        box-sizing: border-box;
        
        // 每五个为一组创建新行
        // &:nth-child(n+6) {
        //   margin-top: 12px;
        // }
        
        // Element UI 复选框样式微调
        .el-checkbox__label {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPc.vue